import { render, staticRenderFns } from "./broadcast-opens.vue?vue&type=template&id=85633000"
import script from "./broadcast-opens.vue?vue&type=script&lang=js"
export * from "./broadcast-opens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports